const API = {
  GET_GET_CONVERSATIONS: {
    path: '/chat/conversations',
    method: 'GET',
  },
  GET_GET_SINGLE_CONVERSATION: {
    path: '/chat',
    method: 'GET',
  },
  POST_UPLOAD_CHAT: {
    path: '/chat/upload',
    method: 'POST',
  },
  PUT_SEND_MESSAGE: {
    path: '/chat/send',
    method: 'PUT',
  },
  POST_SEND_MEETING_MESSAGE: {
    path: '/chat/send-meeting',
    method: 'POST',
  },
  POST_CREATE_CONVERSATION: {
    path: '/chat/create',
    method: 'POST',
  },
  PUT_CLOSE_SESSION: {
    path: '/user-session/close',
    method: 'PUT',
  },
  POST_GOAL_UPDATE: {
    path: '/expert/user/course-goals/update',
    method: 'POST',
  },
  POST_READ_ALL_CONVERSATIONS: {
    path: '/chat/read-all',
    method: 'POST',
  },
  POST_READ_ALL_CHAT_CONVERSATIONS: {
    path: '/chat/:chatId/read-all',
    method: 'POST',
  },
  POST_SEND_FORM_TO_CHATS: {
    path: '/chat/send-form',
    method: 'POST',
  },
  POST_SEND_FORM_INVITE: {
    path: '/chat/send-form-invite',
    method: 'POST',
  },
};
export default API;
